import { UserId } from "./common";

export enum UserRole {
    Client = 'client',
    Agent = 'agent',
    System = 'system',
    Panel = 'panel',
    Admin = 'admin'
}

/** Numeric chat_user.status from ChatWebSocketApi (clients). */
export enum ChatUserStatus {
    Active = 0,
    Warned = 1,
    Banned = 2
}

export const CHAT_USER_STATUS_OPTIONS = [
    { value: ChatUserStatus.Active, label: 'Active' },
    { value: ChatUserStatus.Warned, label: 'Warned' },
    { value: ChatUserStatus.Banned, label: 'Banned' }
] as const;

export interface User {
    id: UserId;
    name: string;
    surname: string;
    nickname: string | null | undefined;
    password?: string;
    email: string;
    role: UserRole;
    external_user_id?: string | null | undefined;
    /** Client chat access status (0 active, 1 warned, 2 banned). */
    status?: ChatUserStatus | number;
    createdAt: Date;
    updatedAt?: Date | string;
    token?: string;
}

export interface UserRegisterRequest {
    name: string;
    surname: string;
    nickname?: string | null;
    email: string;
    password: string;
    role: UserRole;
}

export interface UserUpdateRequest {
    name?: string;
    surname?: string;
    nickname?: string | null;
    password?: string;
    role?: UserRole;
    /** Client chat access status (0 active, 1 warned, 2 banned). */
    status?: ChatUserStatus | number;
}

export interface UserLoginRequest {
    email: string;
    password: string;
}

export interface LoginRequest {
    email: string;
    password: string;
}

export interface UserLoginResponse {
    token: string;
    user: {
        id: UserId;
        email: string;
        role: UserRole;
    };
    error?: string;
}